export default __webpack_public_path__ + "static/tech-nation-1--mobile-145857c2e4ecf0910464e00f743017fc.png";